// src/app/shared/chains.ts
export type ChainInfo = { icon: string; name: string };

export const CHAIN_MAP: Record<number, ChainInfo> = {
  1:     { icon: 'assets/chains/ethereum-eth-logo.svg', name: 'Ethereum' },
  42161: { icon: 'assets/chains/arbitrum-arb-logo.svg', name: 'Arbitrum' },
  137:   { icon: 'assets/chains/polygon-matic-logo.svg', name: 'Polygon' },
  56:    { icon: 'assets/chains/bnb-bnb-logo.svg', name: 'BNB Chain' },
  // tu pourras compléter ici (Base, Linea, etc.)
};

// Helpers optionnels
export const getNetworkName = (id?: number | null) =>
  (id != null ? CHAIN_MAP[id]?.name : undefined) ?? 'Unknown';

export const getNetworkIcon = (id?: number | null) =>
  (id != null ? CHAIN_MAP[id]?.icon : undefined) ?? null;
